import React from "react";

import { TD, TH } from "./table";

import { useArraySelector } from "hooks/redux_hooks";
import { useUserProfileProperties } from "hooks/use_user_properties";
import {
  MonitoringEventTypeType,
  SupportActionMonitoringEventType,
} from "shared/types/monitoring_event";
import { UserType } from "shared/types/user";
import { selectSupportActions } from "store/selectors/monitoring";
import { formatDateTime } from "utils/date";
import { longDisplayName } from "utils/user";

const RESET_ACTION_TYPES = [
  MonitoringEventTypeType.ADMIN_SOFT_RESET_CLASS,
  MonitoringEventTypeType.ADMIN_HARD_RESET_CLASS,
];

function SupportActionHeader() {
  return (
    <thead>
      <tr>
        <TH>Targeted User</TH>
        <TH>Targeted User Role</TH>
        <TH style={{ width: "250px" }}>Support Action</TH>
        <TH>Date</TH>
        <TH>Support Person</TH>
      </tr>
    </thead>
  );
}

function SupportActionBody() {
  const supportActions = useArraySelector(selectSupportActions());
  return (
    <tbody>
      {supportActions.map((supportAction) => {
        return <SupportActionRow key={supportAction.id} supportAction={supportAction} />;
      })}
    </tbody>
  );
}

function formatUserText(userId: string | undefined, user: UserType | null) {
  return userId ? `${userId} - ${longDisplayName(user) || "(not enrolled in class)"}` : "-";
}

function SupportActionRow({ supportAction }: { supportAction: SupportActionMonitoringEventType }) {
  const { userId, timestamp, type } = supportAction;
  const targetUserId = supportAction.contextData.targetUserId || undefined;
  const user = useUserProfileProperties(userId);
  const targetUser = useUserProfileProperties(targetUserId || "");
  const userText =
    RESET_ACTION_TYPES.includes(type) && !userId
      ? "Class Publication"
      : formatUserText(userId, user);

  return (
    <tr>
      <TD>{formatUserText(targetUserId, targetUser)}</TD>
      <TD>{targetUser?.role || "-"}</TD>
      {/* TODO: There might be a CSS issue with long event names */}
      <TD noWrap>{type}</TD>
      <TD noWrap>{formatDateTime(timestamp)}</TD>
      <TD>{userText}</TD>
    </tr>
  );
}

function SupportActionTable() {
  return (
    <table
      className="support-actions fds-table table-hover"
      style={{ tableLayout: "auto" }}
      data-testid="support-action-table"
    >
      <SupportActionHeader />
      <SupportActionBody />
    </table>
  );
}

export { SupportActionHeader, SupportActionBody, SupportActionRow, SupportActionTable };
